import React from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyTextInput from '../../../components/inputs/MyTextInput';

const AgregarCorreo = ({ open, onClose, refresh }) => {

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                Agregar Correo
            </DialogTitle>

            {/* BODY */}

            <DialogContent sx={{ width: 300 }}>

                <Formik
                    initialValues={{
                        email: '',
                    }}
                    validationSchema={Yup.object({
                        email: Yup.string().email('Ingresa un correo valido').required('Ingresa un correo valido'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {

                        try {

                            const response = await myApi.post('/emails/create', values);

                            console.log(response)

                            if(response.data){

                                setSubmitting(false);
                                resetForm();
                                onClose();
                                refresh();

                                Swal.fire({
                                    icon: 'success',
                                    title: 'Correo agregado',
                                });

                            }

                        } catch(e) {

                            console.log(e);
                            setSubmitting(false);
                            resetForm();

                        }   

                    }}
                >
                {({ handleSubmit }) => (

                    <Form>

                        <Grid container spacing={2} marginTop={1}>

                            {/* CORREO */}

                            <Grid size={12}>

                                <MyTextInput
                                    name="email"
                                    label="Correo"
                                />

                            </Grid>

                            {/* FOOTER */}

                            <Grid size={12}>

                                <DialogActions
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid>

                        </Grid>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    ) 

}

export default AgregarCorreo